<template>
  <div>
    <div class="audio-player pt-5 pb-7">
      <div class="flex items-center">
        <div class="player-controls">
          <a href="#" @click.prevent="onPlayClick" v-show="status != 'playing'"
            ><img src="static/img/btn_play.svg" alt=""
          /></a>

          <a href="#" @click.prevent="onPauseClick" v-show="status == 'playing'"
            ><img src="static/img/btn_pause.svg" alt=""
          /></a>
        </div>
        <div class="player-time">{{ seek }}</div>
        <div class="player-progress-wrap">
          <div class="player-progress" :style="progressStyle"></div>
          <div
            class="player-seek-click"
            @mousedown="onProgressClick($event)"
            @touchstart="onProgressClick($event)"
          ></div>
        </div>
        <div class="player-time">{{ duration }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from "howler";
export default {
  name: "AudioPlayer.vue",
  props: ["src"],
  data() {
    return {
      sounds: {
        file: null
      },
      progress: 0,
      seek: 0,
      status: "",
      keepUpdating: true
    };
  },
  computed: {
    duration() {
      if (this.sounds.file != null) {
        return this.formatTime(Math.floor(this.sounds.file.duration()));
      }
      return 0;
    },

    test() {
      return "yes";
    },
    progressStyle() {
      return {
        width: this.progress * 100 + "%"
      };
    }
  },
  methods: {
    createSound(name, src, volume) {
      this.sounds[name] = new Howl({
        src: [src + ".webm", src + ".mp3"],
        volume: volume,
        rate: 1,
        html5: true,
        preload: "metadata"
      });
      this.sounds[name].on("play", this.updatePlayerStatus.bind(this));
      this.sounds[name].on("pause", this.updatePlayerStatus.bind(this));
      /*if (name != "ambience") {
        this.sounds[name].on(
            "end",
            function () {
              this.$bus.$emit("on-audio-end", name);
            }.bind(this)
        );
      }*/
    },
    playSound(name) {
      this.sounds[name].play();
    },
    updatePlayerStatus() {
      if (this.sounds.file.playing()) {
        this.status = "playing";
        this.updateSeek();
      } else {
        this.status = "";
      }
      console.log("update status");
    },
    updateInfo() {
      if (this.sounds.file != null) {
        let tmpSeek = Math.floor(this.sounds.file.seek());
        let tmpDuration = Math.floor(this.sounds.file.duration());
        this.progress = Math.min(1, tmpSeek / tmpDuration);
        this.seek = this.formatTime(tmpSeek);
      } else {
        this.seek = this.formatTime(0);
        this.progress = 0;
      }
    },
    updateSeek() {
      this.updateInfo();
      //console.log(this.seek);
      if (this.sounds.file != null && this.keepUpdating) {
        requestAnimationFrame(this.updateSeek.bind(this));
      }
    },
    formatTime: function (secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = secs - minutes * 60 || 0;

      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    onProgressClick(e) {
      console.log(e.offsetX, e.target.clientWidth);
      let progress = e.offsetX / e.target.clientWidth;
      this.sounds.file.seek(this.sounds.file.duration() * progress);
      this.updateSeek();
    },
    onPlayClick(e) {
      this.sounds.file.play();
    },
    onPauseClick(e) {
      this.sounds.file.pause();
    }
  },
  mounted() {
    this.createSound("file", this.src, 0.94);
    console.log(this.sounds.file);
    this.playSound("file");
    //this.updateSeek();
  },
  beforeDestroy() {
    this.sounds.file.stop();
    this.keepUpdating = false;
  }
};
</script>

<style scoped>
.player-controls {
}
.player-controls img {
  width: 36px;
  height: 36px;
}
.player-progress-wrap {
  background: #efefef;
  width: 100%;
  height: 10px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #e3e3e3;
}
.player-seek-click {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
  opacity: 0.5;
  top: 0;
  left: 0;
  cursor: pointer;
}
.player-progress {
  background: #246bf5;
  height: 100%;
}
.player-time {
  font-size: 11px;
  text-align: center;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AudioPlayer.vue